import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';

import './mutators/convertToServiceInboxRemindersMutator';
export { convertToServiceInboxReminders } from './actions/inboxRemindersActions';
export { default as EmailReminderEntrySource } from './store/schema/EmailReminderEntrySource';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "EmailReminders"*/ './lazyIndex')
);

export { default as ReminderContainer } from './components/EmailReminderContainer';
export { default as ReminderDropdown } from './components/ReminderDropdown';
export { default as logInboxReminderOffsetsForCompose } from './utils/logInboxReminderOffsetsForCompose';

// Delayed Loaded Components
export const EmailReminderDialog = createLazyComponent(lazyModule, m => m.EmailReminderDialog);

export const showEmailReminderDialogLazy = new LazyImport(
    lazyModule,
    m => m.showEmailReminderDialog
);

export { updateCalendarEventByEmailReminders } from './actions/publicActions';
